module.exports = __webpack_public_path__ + "img/download_pattern_left.c9bfe9ae.png";